<template>
    <div class="padding-10">
        <a-divider orientation="left">逆变器管理</a-divider>

        <div class="search-div">
            <div class="table-page-search-wrapper">
                <a-form layout="inline">
                    <a-row :gutter="12">
                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label="集团">
                                <group-select-list ref="groupSelect" @changeGroup="changeGroup"></group-select-list>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label="场站">
                                <station-select-list ref="stationSelect" @changeStation="changeStation"></station-select-list>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label=" " :colon="false">
                             <span class="table-page-search-submitButtons">
                              <a-button type="primary" @click="initTable">查询</a-button>
                             </span>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </div>

        <div class="table-tools-right">
            <a-button-group >
                <a-button  @click="initTable"><i class="fa fa-refresh icon"></i>  刷新</a-button>
                <a-button type="primary" @click="add"><i class="fa fa-plus icon"></i>  新增</a-button>
            </a-button-group>
        </div>
        <a-table :loading="loading"
                 :columns="columns"
                 :dataSource="data"
                 bordered
                 @change="changeOrder"
                 :scroll="{x:  '150%'}"
                 :pagination="pagination"
        >
                   <span slot="id" slot-scope="text, record, index">
                        <template>
                            <span>{{index + 1}}</span>
                        </template>
                  </span>

            <span slot="option" slot-scope="text, record, index">
                        <template>
                            <div class="btn">
                                <span class="badge-success" @click="edit(record)">编辑</span>
                                <a-popconfirm
                                        title="真的要删除该逆变器吗？"
                                        @confirm="confirm(record)"
                                        okText="是"
                                        cancelText="否"
                                >
                                    <span class="badge-danger" >删除</span>
                                </a-popconfirm>
                            </div>
                        </template>
                  </span>
        </a-table>

        <a-modal title="添加逆变器" v-model="addModel.visible" @ok="handleOk" :maskClosable="false">
            <div class="search-div">
                <div class="table-page-search-wrapper">
                    <a-form :form="form" layout="inline">
                        <a-row :gutter="12">
                            <a-form-item label="集团" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <group-select-list :all="false" ref="groupSelectAdd" @changeGroup="changeGroup2"></group-select-list>
                            </a-form-item>

                            <a-form-item label="场站" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <station-select-list :all="false" ref="stationSelectAdd" @changeStation="changeStation2"></station-select-list>
                            </a-form-item>

                            <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['name', { rules: [{ required: true, message: '名称不能为空' }] }]"/>
                            </a-form-item>

                            <a-form-item label="设备序列号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input  v-decorator="['sequence', { rules: [{ required: true, message: '设备序列号不能为空' },{ required: true, max: 8, message: '设备序列号不能超过8位' }] }]"/>
                            </a-form-item>

                            <a-form-item label="组件容量" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input-number placeholder="请输入数字类型" :style="{'width': '100%'}" v-decorator="['capacity', { rules: [{ required: true, validator: handleCapacity}] }]"/>
                            </a-form-item>

                            <a-form-item label="品牌" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-select  v-decorator="['brand', { rules: [{ required: true, validator: handleBrand }] }]">
                                    <a-select-option v-for="item in staticParam.brand" :key="item.id" :value="item.name" >{{item.name}}</a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item label="型号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-select  v-decorator="['model', { rules: [{ required: true, validator: handleModel }] }]">
                                    <a-select-option v-for="item in staticParam.model" :key="item.id" :value="item.name" >{{item.name}}</a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item label="协议" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-select  v-decorator="['protocol', { rules: [{ required: true, validator: handleProtocol }] }]">
                                    <a-select-option v-for="item in staticParam.protocol" :key="item.id" :value="item.name" >{{item.name}}</a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item label="厂家" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-select v-decorator="['vender', { rules: [{ required: true, validator: handleVender }] }]">
                                    <a-select-option  v-for="item in staticParam.vender" :key="item.id" :value="item.name">{{item.name}}</a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item label="slave地址" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input-number :min="1" :max="255" :precision="0" :style="{'width': '100%'}" placeholder="请输入整数类型" v-decorator="['slaveAddr', { rules: [{ required: true, message: 'slave地址不能为空' }] }]"/>
                            </a-form-item>

                            <a-form-item label="组件路数" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input-number :precision="0" :style="{'width': '100%'}" placeholder="请输入整数类型" v-decorator="['seriesCount', { rules: [{ required: true, message: '组件路数不能为空' }] }]"/>
                            </a-form-item>

                            <a-form-item label="组件串数" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input-number :precision="0" :style="{'width': '100%'}" placeholder="请输入整数类型" v-decorator="['subassemblyCount', { rules: [{ required: true, message: '组件串数不能为空' }] }]"/>
                            </a-form-item>

                        </a-row>
                    </a-form>
                </div>
            </div>
        </a-modal>

        <a-modal title="修改逆变器" v-model="editModel.visible" @ok="handleEditOk" :maskClosable="false">
            <div class="search-div">
                <div class="table-page-search-wrapper">
                    <a-form :form="editForm" layout="inline">
                        <a-row :gutter="12">

                            <a-form-item label="集团" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <group-select-list :all="false" ref="groupSelectEdit" @changeGroup="changeGroup3"></group-select-list>
                            </a-form-item>

                            <a-form-item label="场站" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <station-select-list :all="false" ref="stationSelectEdit" @changeStation="changeStation3"></station-select-list>
                            </a-form-item>

                            <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['name', { rules: [{ required: true, message: '名称不能为空' }] }]"/>
                            </a-form-item>

                            <a-form-item label="设备序列号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input  v-decorator="['sequence', { rules: [{ required: true, message: '设备序列号不能为空' },{ required: true, max: 8, message: '设备序列号不能超过8位' }] }]"/>
                            </a-form-item>

                            <a-form-item label="组件容量" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input-number placeholder="请输入数字类型" :style="{'width': '100%'}" v-decorator="['capacity', { rules: [{ required: true, validator: handleCapacity}] }]"/>
                            </a-form-item>

                            <a-form-item label="品牌" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-select  v-decorator="['brand', { rules: [{ required: true, validator: handleBrand }] }]">
                                    <a-select-option v-for="item in staticParam.brand" :key="item.id" :value="item.name" >{{item.name}}</a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item label="型号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-select  v-decorator="['model', { rules: [{ required: true, validator: handleModel }] }]">
                                    <a-select-option v-for="item in staticParam.model" :key="item.id" :value="item.name" >{{item.name}}</a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item label="协议" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-select  v-decorator="['protocol', { rules: [{ required: true, validator: handleProtocol }] }]">
                                    <a-select-option v-for="item in staticParam.protocol" :key="item.id" :value="item.name" >{{item.name}}</a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item label="厂家" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-select v-decorator="['vender', { rules: [{ required: true, validator: handleVender }] }]">
                                    <a-select-option  v-for="item in staticParam.vender" :key="item.id" :value="item.name">{{item.name}}</a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item label="slave地址" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input-number :min="1" :max="255" :precision="0" :style="{'width': '100%'}" placeholder="请输入整数类型" v-decorator="['slaveAddr', { rules: [{ required: true, message: 'slave地址不能为空' }] }]"/>
                            </a-form-item>

                            <a-form-item label="组件路数" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input-number :precision="0" :style="{'width': '100%'}" placeholder="请输入整数类型" v-decorator="['seriesCount', { rules: [{ required: true, message: '组件路数不能为空' }] }]"/>
                            </a-form-item>

                            <a-form-item label="组件串数" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input-number :precision="0" :style="{'width': '100%'}" placeholder="请输入整数类型" v-decorator="['subassemblyCount', { rules: [{ required: true, message: '组件串数不能为空' }] }]"/>
                            </a-form-item>
                        </a-row>
                    </a-form>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
    import moment from "moment"
    import groupSelectList from "../components/common/groupSelectList";
    import stationSelectList from "../components/common/stationSelectList";

    const columns = [
        {
            title: 'id',
            key: 'id',
            dataIndex: 'id',
            sorter: true,
            scopedSlots: {customRender: "id"},
        },
        {
            title: '名称',
            key: 'name',
            dataIndex: 'name',
            sorter: true
        },

        {
            title: '场站',
            key: 'powerStationName',
            dataIndex: 'powerStationName',
            sorter: true
        },
        {
            title: '集团',
            key: 'groupName',
            dataIndex: 'groupName',
            sorter: true
        },
        {
            title: '类型',
            key: 'typeName',
            dataIndex: 'typeName',
            sorter: true,
        },
        {
            title: '组件容量',
            key: 'capacity',
            dataIndex: 'capacity',
            sorter: true,
        },
        {
            title: '设备序列号',
            key: 'sequence',
            dataIndex: 'sequence',
            sorter: true
        },
        {
            title: '品牌',
            key: 'brand',
            dataIndex: 'brand',
            sorter: true
        },
        {
            title: '型号',
            key: 'model',
            dataIndex: 'model',
            sorter: true
        },
        {
            title: '协议',
            key: 'protocol',
            dataIndex: 'protocol',
            sorter: true
        },
        {
            title: '厂家',
            key: 'vender',
            dataIndex: 'vender',
            sorter: true
        },
        {
            title: 'slave地址',
            key: 'slaveAddr',
            dataIndex: 'slaveAddr',
            sorter: true
        },
        {
            title: '创建时间',
            key: 'activeTime',
            dataIndex: 'activeTime',
            sorter: true
        },
        {
            title: '操作',
            key: 'option',
            dataIndex: 'option',
            sorter: true,
            scopedSlots: {customRender: "option"},
            width: 150,
            fixed: 'right'
        }


    ];
    export default {
        name: "inverter",
        components:{
            groupSelectList,
            stationSelectList
        },
        data(){
            return {
                labelCol: {
                    span: 6
                },
                columns,
                data: [],
                form: this.$form.createForm(this),
                editForm: this.$form.createForm(this),
                queryParam:{
                    role: 0,
                },
                queryParams:{
                    sortName: 'id',
                    sortOrder: 'asc',
                    page: 1,
                    size: 10
                },
                order: {
                    ascend: 'asc',
                    descend: 'desc'
                },
                loading: false,
                pagination: {
                    total: 0,
                    current: 1,
                    // defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10','20','50','100']
                },
                staticParam:{
                    protocol:[],
                    vender: [],
                    brand: [],
                    model: []
                },
                addModel:{
                    visible: false,
                    groupId: '',
                    station: '',
                },
                editModel:{
                    visible: false,
                    obj: null,
                    groupId: '',
                    station: '',
                },
                groupId: 0,
                stationId: 0,
            }
        },

        methods:{
            changeGroup(id){
                this.groupId = id;
                this.$refs.stationSelect.loadStation(id);
            },
            changeStation(id){
                this.stationId = id;
                this.initTable();
            },
            async initTable(){
                this.loading = true;
                let result = await this.$http.get(this.$baseURL.findInverterPage({groupId: this.groupId, powerStationId: this.stationId }, this.queryParams));
                console.log(result)
                this.data = result.list;
                this.pagination.current = result.pageNum;
                this.pagination.total = result.total;
                this.loading = false;

                console.log(this.pagination)
            },

            changeOrder(pagination, filters, sorter){
                console.log(pagination ,sorter)
                this.queryParams.page = pagination.current;
                this.queryParams.sortName = sorter.columnKey ? sorter.columnKey : 'id';
                this.queryParams.sortOrder = sorter.order ? this.order[sorter.order] : 'asc';
                this.initTable()
            },


            async add(){
                this.addModel.visible = true;
                await this.loadProtocol();
                await this.loadVerder();
                await this.loadModel();
                await this.loadBrand();
                this.$nextTick(()=>{
                    this.form.setFieldsValue({
                        "name": '',
                        "sequence": '',
                        "capacity": '',
                        "brand": '',
                        "model": '',
                        "slaveAddr": '',
                        "seriesCount": '',
                        "subassemblyCount": '',
                    })
                })
            },

            handleOk(e){
                e.preventDefault();
                const { form: { validateFields }} = this;
                validateFields(["name","sequence","capacity","brand",'protocol','vender',
                    "model", "slaveAddr","seriesCount","subassemblyCount"
                ], { force: true }, (err, values) => {
                    if (!err) {
                        let groupId = Number(this.addModel.groupId);
                        let station = Number(this.addModel.station);
                        if(groupId !== -1 || groupId !== 0){
                            if(station !== -1 || station !== 0){
                                if (!err) {
                                    let params = { ...values };
                                    params.groupId = groupId;
                                    params.powerStationId = station;
                                    params.type = 1;
                                    //params.protocol = this.addModel.protocol;
                                    //params.vender = this.addModel.vender;
                                    this.addInverter(params);
                                    console.log(params)
                                }
                            } else {
                                this.$message.error('请先添加场站');
                            }
                        } else {
                            this.$message.error('请先添加集团');
                        }

                    }
                })
            },
            async addInverter(obj){
                await this.$http.postJson(this.$baseURL.manageInverter(), obj);
                this.$Utils.showSuccess({title: '添加成功'});
                this.addModel.visible = false;
                this.initTable();
            },
            /**********编辑**********/

            async edit(data){
                console.log(data);
                this.editModel.visible = true;
                this.editModel.obj = data;
                await this.loadProtocol();
                await this.loadVerder();
                await this.loadModel();
                await this.loadBrand();
                this.$nextTick(()=>{
                    this.$refs.groupSelectEdit.updateSelectId(data)
                    this.$refs.stationSelectEdit.updateSelectId(data)
                    this.editModel.protocol = data.protocol;
                    this.editModel.vender = data.vender;
                    this.editForm.setFieldsValue({
                        'name': data.name,
                        "sequence": data.sequence,
                        "capacity": data.capacity,
                        "brand": data.brand,
                        "model": data.model,
                        "protocol": data.protocol,
                        "vender": data.vender,
                        "slaveAddr": data.slaveAddr,
                        "seriesCount": data.seriesCount,
                        "subassemblyCount": data.subassemblyCount,
                    })
                })

            },

            handleEditOk(e){
                e.preventDefault();
                const { editForm: { validateFields }} = this;
                validateFields(["name","sequence","capacity","brand",'protocol','vender',
                    "model", "slaveAddr","seriesCount","subassemblyCount"], { force: true }, (err, values) => {
                    if (!err) {
                        let groupId = Number(this.editModel.groupId);
                        let station = Number(this.editModel.station);
                        if(groupId !== -1 || groupId !== 0){
                            if(station !== -1 || station !== 0){
                                if (!err) {
                                    let params = { ...values };
                                    params.groupId = groupId;
                                    params.powerStationId = station;
                                    //params.protocol = this.editModel.protocol;
                                    //params.vender = this.editModel.vender;
                                    this.eddInverter(params);
                                    console.log(params)
                                }
                            } else {
                                this.$message.error('请先添加场站');
                            }
                        } else {
                            this.$message.error('请先添加集团');
                        }

                    }

                })
            },
            async eddInverter(obj){
                obj.id = this.editModel.obj.id;
                await this.$http.putJson(this.$baseURL.manageInverter(), obj);
                this.$Utils.showSuccess({title: '修改成功'});
                this.editModel.visible = false;
                this.initTable();
            },
            /************删除*************/
            async confirm(data){
                console.log(data)
                await this.$http.deleteJson(this.$baseURL.inverterDeleteById(data.id));
                this.$Utils.showSuccess({title: '删除成功'});
                this.initTable();
            },

            /***********重置**********/
            changeGroup2(id){
                this.addModel.groupId = id;
                this.$refs.stationSelectAdd.loadStation(id);
            },
            changeGroup3(id){
                this.editModel.groupId = id;
                this.$refs.stationSelectEdit.loadStation(id);
            },
            changeStation2(id){
                this.addModel.station = id;
            },
            changeStation3(id){
                this.editModel.station = id;
            },
            /**************自定义校验**************/
            handleCapacity(rule,value, callback){
                if(value.length > 11){
                    callback('组件容量不能超过11位')
                }
                callback()
            },
            handleProtocol(rule,value, callback){
                if(value === undefined || value === null  || value.length === 0){
                    callback('协议不能为空，请选择')
                } else if(value === -1){
                    callback('协议不能为空，请先从后台添加')
                }
                callback()
            },
            handleVender(rule,value, callback){
                if(value === undefined || value === null || value.length === 0){
                    callback('厂家不能为空，请选择')
                } else if(value === -1){
                    callback('厂家不能为空，请先从后台添加')
                }
                callback()
            },
            handleBrand(rule,value, callback){
                if(value === undefined || value === null  || value.length === 0){
                    callback('品牌不能为空，请选择')
                } else if(value === -1){
                    callback('品牌不能为空，请先从后台添加')
                }
                callback()
            },
            handleModel(rule,value, callback){
                if(value === undefined || value.length === 0){
                    callback('型号不能为空，请选择')
                } else if(value === -1){
                    callback('型号不能为空，请先从后台添加')
                }
                callback()
            },
            async loadProtocol(){
                let result = await this.$http.get(this.$baseURL.protocolList());
                this.staticParam.protocol = result.dictItemList;
            },
            async loadVerder(){
                let result = await this.$http.get(this.$baseURL.verderList());
                this.staticParam.vender = result.dictItemList;
            },
            async loadModel(){
                let result = await this.$http.get(this.$baseURL.modelList());
                this.staticParam.model = result.dictItemList;
            },
            async loadBrand(){
                let result = await this.$http.get(this.$baseURL.brandList());
                this.staticParam.brand = result.dictItemList;
            }


        },
        computed:{
            wrapperCol(){
                return {span: 24 - this.labelCol.span};
            }
        }
    }
</script>

<style lang="less" scoped>

    .table-tools-right {
        display: flex;
        flex-direction: row-reverse;
        margin-bottom: 15px;
    }

    .icon{
        margin-right: 5px;
    }
    .btn {
        span{
            display: inline-block;
            padding: 3px 10px;
            margin-right: 5px;
            &:hover{
                cursor: pointer;
            }
        }
        .badge-success:hover {
            background: #1890ff;
        }

        .badge-danger:hover{
            background: #ed3543;
        }

    }
</style>
